<select [ngClass]="cssClass" [(ngModel)]="value" [required]="required" [disabled]="disabled">
  <option value="">{{ prompt }}</option>
  <option value="All_Members">{{ 'profiles.search.advanced.common-data-views.view-names.all-members' | translate | titlecase }}</option>
  <option value="All_Members_And_Main_Contacts">{{
    'profiles.search.advanced.common-data-views.view-names.all-members-and-main-contacts' | translate | titlecase
  }}</option>
  <option value="All_Members_And_Profiles_Who_Receive_Communication">{{
    'profiles.search.advanced.common-data-views.view-names.all-members-and-profiles-who-receive-communication' | translate | titlecase
  }}</option>
  <option value="All_Members_And_Primary_Relations">{{
    'profiles.search.advanced.common-data-views.view-names.all-members-and-primary-relations' | translate | titlecase
  }}</option>
  <option value="All_Individuals_Who_Receive_Communication_From_A_Member">{{
    'profiles.search.advanced.common-data-views.view-names.all-individuals-who-receive-communication-from-a-member' | translate | titlecase
  }}</option>
  <option value="All_Individuals_Who_Receive_Communication_From_A_Member_Excluding_The_Main_Contact">{{
    'profiles.search.advanced.common-data-views.view-names.all-individuals-who-receive-communication-from-a-member-excluding-the-main-contact'
      | translate
      | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_Invoices">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_Invoices_30_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-30-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_Invoices_60_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-60-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_Invoices_90_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-90-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_Invoices_120_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-invoices-120-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Invoices_Coming_Due_In_The_Next_7_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-7-days' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Invoices_Coming_Due_In_The_Next_14_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-14-days'
      | translate
      | titlecase
  }}</option>
  <option value="All_Profiles_With_Invoices_Coming_Due_In_The_Next_30_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-30-days'
      | translate
      | titlecase
  }}</option>
  <option value="All_Profiles_With_Invoices_Coming_Due_In_The_Next_60_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-invoices-coming-due-in-the-next-60-days'
      | translate
      | titlecase
  }}</option>
  <option value="All_Organizations">{{
    'profiles.search.advanced.common-data-views.view-names.all-organizations' | translate | titlecase
  }}</option>
  <option value="All_Individuals">{{
    'profiles.search.advanced.common-data-views.view-names.all-individuals' | translate | titlecase
  }}</option>
  <option value="All_Prospects">{{ 'profiles.search.advanced.common-data-views.view-names.all-prospects' | translate | titlecase }}</option>
  <option value="All_My_Prospects">{{
    'profiles.search.advanced.common-data-views.view-names.all-my-prospects' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_DUES_Invoices">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_DUES_Invoices_15_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-15-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_DUES_Invoices_30_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-30-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_DUES_Invoices_60_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-60-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_DUES_Invoices_90_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-90-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_Unpaid_DUES_Invoices_120_Days_Past_Due">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-unpaid-dues-invoices-120-days-past-due' | translate | titlecase
  }}</option>
  <option value="All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_7_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-7-days'
      | translate
      | titlecase
  }}</option>
  <option value="All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_14_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-14-days'
      | translate
      | titlecase
  }}</option>
  <option value="All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_30_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-30-days'
      | translate
      | titlecase
  }}</option>
  <option value="All_Profiles_With_DUES_Invoices_Coming_Due_In_The_Next_60_Days">{{
    'profiles.search.advanced.common-data-views.view-names.all-profiles-with-dues-invoices-coming-due-in-the-next-60-days'
      | translate
      | titlecase
  }}</option>
</select>
